import gql from 'graphql-tag'

export const QUERY_GET_GENERIC_CAMPAIGNS_PRODUCTS_BY_ID = gql`
  query GenericCampaign($_id: ID!) {
    genericCampaign(_id: $_id) {
      products {
        _id
        sku
        created_at
        eans
        ean
        name
        updated_at
      }
    }
  }
`
